// extracted by mini-css-extract-plugin
export default {"parent":"style_parent__RtXbr","child1":"style_child1__hY43w","child2":"style_child2__YqY-K"};